var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, avoidHandler, Defaults, ViewChild, Utils } from '@pacem/pacem-core';
import { PacemTextualInputElement } from './input';
import { CHAR_COUNTER_CHILD } from './char-counter';
//namespace Pacem.Components.Scaffolding {
let PacemPasswordInputElement = class PacemPasswordInputElement extends PacemTextualInputElement {
    constructor() {
        super();
        this._togglerMousedownHandler = (evt) => {
            if (evt.button == 0) {
                avoidHandler(evt);
                this.toggleVisibility();
            }
        };
    }
    get inputFields() {
        return [this._input];
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        const baseId = this.id ?? '_' + Utils.uniqueCode();
        const inputId = this._input.id = baseId + '_ctrl';
        this._toggler.setAttribute('aria-controls', inputId);
        this._toggler.setAttribute('role', 'button');
        this._syncToggler();
        this._toggler.addEventListener('mousedown', this._togglerMousedownHandler, false);
    }
    disconnectedCallback() {
        if (!Utils.isNull(this._toggler)) {
            this._toggler.removeEventListener('mousedown', this._togglerMousedownHandler, false);
        }
    }
    toggleVisibility() {
        const current = this._input.type;
        this._input.type = current === 'password' ? 'text' : 'password';
        this._syncToggler();
    }
    _syncToggler() {
        const collapsed = this._input.type === 'password';
        this._toggler.innerText = collapsed ? 'visibility_off' : 'visibility';
        this._toggler.setAttribute('aria-expanded', (!collapsed).toString());
    }
    toggleReadonlyView(readonly) {
        this._input.hidden = this._toggler.hidden = readonly;
        this._span.hidden = !readonly;
    }
    getViewValue(val) {
        return Utils.leftPad('', Math.floor(8 + 3 * Math.random()), '•');
    }
};
__decorate([
    ViewChild('input[type=password]')
], PacemPasswordInputElement.prototype, "_input", void 0);
__decorate([
    ViewChild(`span.${PCSS}-readonly`)
], PacemPasswordInputElement.prototype, "_span", void 0);
__decorate([
    ViewChild(`i.${PCSS}-icon.${PCSS}-clickable`)
], PacemPasswordInputElement.prototype, "_toggler", void 0);
PacemPasswordInputElement = __decorate([
    CustomElement({
        tagName: P + '-input-password', template: `<input type="password" class="${PCSS}-input ${PCSS}-viewfinder" /><i class="${PCSS}-icon ${PCSS}-clickable"></i>
${CHAR_COUNTER_CHILD}<span class="${PCSS}-readonly"><${P}-text text="{{ :host.viewValue }}"></${P}-text></span>`, shadow: Defaults.USE_SHADOW_ROOT
    })
], PacemPasswordInputElement);
export { PacemPasswordInputElement };
